import vue from "../main"
import moment from "moment"
import ajaxRequest from '@/api/ajax_download.js'
import download_file from "downloadjs";
import {add_action_log,} from "@/api/common";


// 获取blob数据
// function getBlob(url, cb) {
//   ajaxRequest(url, { responseType: 'blob' }).then(res => {
//     cb(res,res.type);
//   })
// }
const util = {
  showPhoneOrEmail(phone, email) {
    let tmp = email == null ? "" : email.toLowerCase();
    if (tmp.indexOf("@nike.com") >= 0) {
      return email;
    } else {
      return phone;
    }
  },
  format_time(time) {
    const time_obj = moment.duration(time, "seconds");
    const hour =
      +time_obj.hours() < 10 ? "0" + time_obj.hours() : time_obj.hours();
    const min =
      +time_obj.minutes() < 10
        ? "0" + time_obj.minutes()
        : time_obj.minutes();
    const seconds =
      +time_obj.seconds() < 10
        ? "0" + time_obj.seconds()
        : time_obj.seconds();
    return hour + ":" + min + ":" + seconds;
  },
  // 下载文件, filename需要包括后缀名
  downloadFile(url, filename) {
    let ua = navigator.userAgent.toLowerCase()

    let isChromeOrSafari = ua.includes('Chrome')||ua.includes('Safari')
    ajaxRequest(url, {responseType: 'blob'}).then(res => {
      if (ua.includes("mac") || ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1){
          let link = document.createElement("a")
          link.href = url
          link.download = filename
          link.click()
          link.remove()
        if(!isChromeOrSafari){
          vue.$Message.warning({
            content: '请使用safari、chrome或者Edge浏览器下载文件，其他浏览器可能下载失败',
            duration: 5,
            closable: true
          })
        }
      } else{
        download_file(res, filename, res.type)
      }

    })


  },

  localStorage_getItem(key) {
    return JSON.parse(localStorage.getItem(key))
  },
  localStorage_setItem(key, val) {
    localStorage.setItem(key, JSON.stringify(val))
  },
  //清空参数
  clearObject(obj) {
    Object.keys(obj).forEach((key) => (obj[key] = ''));
  },

  //添加editable的属性
  addEditable(obj, defaultEditable) {
    obj.forEach(item => {
      item.editable = defaultEditable == undefined ? false : defaultEditable;
    });

    return obj;
  },

  //统一success message box
  showSuccess(key) {
    let message = vue.$t("successMsg['" + key + "']");
    vue.$Message.success(message);
  },

  //统一error message box
  showError(key) {
    let message = vue.$t("errMsg['" + key + "']");
    vue.$Message.error({
      content: message,
      duration: 10,
      closable: true
    });
  },

  //统一confirm的modal
  //object: msgKey, successCB, cancelCB
  confirmModal(obj) {
    vue.$Modal.confirm({
      title: vue.$t("warning"),
      content: '<p>' + vue.$t("confirmMsg['" + obj.msgKey + "']") + '</p>',
      okText: vue.$t('event_detail.confirmed_status.CONFIRMED'),
      cancelText: vue.$t('cancel'),
      onOk: () => {
        if (obj.successCB) obj.successCB();
      },
      onCancel: () => {
        if (obj.cancelCB) obj.cancelCB();
      }
    });
  },

  //表格下载通用方法
  downloadExcel(res, name) {
    let blob = new Blob([res]);
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name + '_' + moment().format("YYYYMMDDHHmmss") + '.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  formatTime(time, format) {
    return moment(time).format(format)
  },

  toWeekDay(time) {
    let wd ;
    if (moment(time).isValid()) {
      wd =  moment(time).weekday()
    } else {
      return ''
    }
    if (vue.$i18n.locale == 'en') {
      switch (wd) {
        case 1:
          return 'MONDAY';
        case 2:
          return 'TUESDAY';
        case 3:
          return 'WEDNESDAY';
        case 4:
          return 'THURSDAY';
        case 5:
          return 'FRIDAY';
        case 6:
          return 'SATURDAY';
        case 7:
          return 'SUNDAY';
      }
    } else {
      switch (wd) {
        case 1:
          return '星期一';
        case 2:
          return '星期二';
        case 3:
          return '星期三';
        case 4:
          return '星期四';
        case 5:
          return '星期五';
        case 6:
          return '星期六';
        case 7:
          return '星期日';
      }
    }
  },
  // 传入秒数, 获取时长
  additionalDuration(session = {}) {
    let duration;
    let start_time;
    let end_time;
    if (session.additional_duration) {
      duration = session.additional_duration
    } else {
      if (session.interaction_session_type !== 3) {
        start_time = session.start_time
        end_time = session.end_time
      } else {
        start_time = session.interaction_playback_start_time
        end_time = session.interaction_playback_end_time
      }
      duration = (moment(end_time).unix() - moment(start_time).unix())
    }
    console.log(duration, "durationdurationdurationdurationdurationdurationdurationdurationdurationduration")
    if (duration) {
      const durationObj = moment.duration(
        duration,
        "seconds"
      );
      return (
        durationObj
          .hours()
          .toString()
          .padStart(2, "0") +
        ":" +
        durationObj
          .minutes()
          .toString()
          .padStart(2, "0") +
        ":" +
        durationObj
          .seconds()
          .toString()
          .padStart(2, "0")
      );
    }
    return null;
  },
  listTag(str) {
    if (typeof str === "string") {
      if (str.split(";").length > 1) {
        // const arr = str.split(";");
        return str.split(";").join("<br/>");
      }
    }
  },
  add_action_log(module, obj, event_id, session_id) {//增加操作日志
    let self = this;
    try {
      add_action_log({
        from_module: module,
        from_object: JSON.stringify(obj),
        event_id: event_id,
        session_id: session_id,
      }).then((res) => {

      });
    } catch (error) {

    }
  },

  // 抓取当前页中当前视频的当时截图(注：抓取的是阿里云播放器的video元素)quality:0 - 1.0
  getCurrentSnapShot(quality) {
    let c = document.getElementById('forSnapShot')
    let video = document.getElementById("J_prismPlayer").children[0];
    let width = video.videoWidth
    // console.log('current wid', width)
    c.setAttribute("width", width)
    let height = video.videoHeight
    c.setAttribute("height", height)
    let ctx = c.getContext("2d");
    ctx.drawImage(video, 0, 0, width, height, 0, 0, width, height);
    let fullQualityJPG = c.toDataURL("image/jpeg", quality);// 图片质量
    return fullQualityJPG
  },

  // 添加水印
  async addWaterMark(url, name, phone, email) {
    const img = document.createElement("img");
    img.src = url;
    img.setAttribute("crossOrigin", "anonymous"); // 防止跨域引起的 Failed to execute 'toDataURL' on 'HTMLCanvasElement': Tainted canvases may not be exported.
    await new Promise((resolve) => (img.onload = resolve));
    // 创建canvas DOM元素，并设置其宽高和图片一样
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    // 坐标(0,0) 表示从此处开始绘制，相当于偏移。
    canvas.getContext("2d").drawImage(img, 0, 0);
    // 添加水印
    const ctx = canvas.getContext("2d");
    ctx.textAlign = "left";
    ctx.textBaseline = "top";
    ctx.font = "40px OneNikeCurrency, 'FuturaW01-ExtraBoldCond 774896', Futura-CondensedMedium, Roboto-Condensed-Light";
    ctx.fillStyle = " #757575"
    ctx.lineWidth = 50
    ctx.translate(0, 0);

    //水印密度
    for (let i = 0; i < 5; i++) {
      for (let j = 0; j < 4; j++) {
        ctx.rotate((Math.PI / 180) * -40);//旋转
        let random = (Math.floor(Math.random() * 10) + 1) * 5
        ctx.fillText(name, i * img.width / 5 + i * img.width / 10 - 100, j * img.height / 3 + 20 + j * img.height / 6 - 80 + random, img.width);
        ctx.fillText(phone, i * img.width / 5 + i * img.width / 10 - 100, j * img.height / 3 + 20 + 40 + j * img.height / 6 - 80 + random, img.width);
        ctx.fillText(email, i * img.width / 5 + i * img.width / 10 - 100, j * img.height / 3 + 20 + 80 + j * img.height / 6 - 80 + random, img.width);
        ctx.rotate((Math.PI / 180) * 40);//旋转
      }
    }

    // canvas.toDataURL 返回的是一串Base64编码的URL
    let base64 = canvas.toDataURL("image/jpeg");
    // console.log('图片',base64)
    return base64
  },

  // 节流: wait期间func只执行一次（根据func_name识别）
  taskArr: [],
  throttle(func, func_name, wait) {
    let self = this
    if (self.taskArr.indexOf(func_name) == -1) {
      self.taskArr.push(func_name)
      func()
      setTimeout(_ => {
        self.taskArr.splice(self.taskArr.indexOf(func_name), 1)
      }, wait)
    }

  }
}

export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js